<template>
  <div>
    <BaseElFormItem
      v-if="useBindClassTickets"
      label="綁定堂票"
      prop="classTickets"
    >
      <BaseElSelect
        v-model="syncClassTickets"
        popper-class="select-popper"
        testName="formData_classTickets_bind"
        placeholder="選擇堂票"
        multiple
        collapse-tags
        @visible-change="showSelector = true"
        @change="onClassTicketsChange"
      >
        <BaseElSelectOption
          v-for="classTicket in displayClassTicketOptions"
          :key="classTicket.value"
          :label="classTicket.label"
          :value="classTicket.value"
        />
      </BaseElSelect>
    </BaseElFormItem>

    <BaseElFormItem v-if="syncClassTickets.length" label="此服務項目僅供堂票預約">
      <BaseElSwitch
        v-model="syncRequiredClassTicket"
        testName="formData_requiredClassTicket"
        inactive-text="否"
        active-text="是"
      />
    </BaseElFormItem>

    <!--
      選擇器用固定的容器包起來，不要跟上面的 v-if 表單列當同層兄弟節點。
      ClassTicketAdvanceSelect 的根節點是 el-dialog append-to-body，掛載後 DOM 會被搬到 body，
      但 vdom 仍把它當成這層的子節點；確認選擇時「堂票有值」與「關閉選擇器」會落在同一次 patch，
      Vue 的 diff 會拿已經被搬走的 dialog 節點當 insertBefore 的參考點而丟出 NotFoundError，
      patch 中斷後遮罩留在畫面上，看起來就是整頁卡死。 [CBGISSUE-275]
    -->
    <div class="class-ticket-selector-anchor">
      <ClassTicketAdvanceSelect
        v-if="showSelector"
        :data="classTicketList"
        :selectedData="syncClassTickets"
        :disabledExp="false"
        multiple
        @confirm="onSelected"
        @close="onClose"
        @filter="onFilter"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'
import { useVModel } from '@vueuse/core'
import ClassTicketAdvanceSelect from '@/components/Select/ClassTicketAdvanceSelect.vue'
import { map } from 'lodash'

export default defineComponent({
  name: 'BindClassTicketBlock',
  components: { ClassTicketAdvanceSelect },
  props: {
    classTickets: { type: Array, default: () => ([]) },
    requiredClassTicket: Boolean,
    useBindClassTickets: Boolean,
    classTicketList: { type: Array, default: () => ([]) },
  },
  emits: ['update:value', 'filter', 'close'],
  setup (props, { emit }) {
    const syncClassTickets = useVModel(props, 'classTickets', emit)
    const syncRequiredClassTicket = useVModel(props, 'requiredClassTicket', emit)
    const showSelector = ref(false)

    const onSelected = (classTicketIds) => {
      if (!classTicketIds.length) {
        syncRequiredClassTicket.value = false
        return
      }
      syncClassTickets.value = classTicketIds
    }

    const onClassTicketsChange = (tickets) => {
      if (!tickets.length) {
        syncRequiredClassTicket.value = false
      }
    }

    const displayClassTicketOptions = computed(() => {
      return map(props.classTicketList, i => ({
        label: i.name,
        value: i.id,
      }))
    })

    const onFilter = (filters) => {
      emit('filter', filters)
    }

    const onClose = () => {
      showSelector.value = false
      emit('close')
    }

    return { syncClassTickets, showSelector, displayClassTicketOptions, onSelected, syncRequiredClassTicket, onClassTicketsChange, onFilter, onClose }
  },
})

</script>

<style lang="postcss" scoped>

</style>
